import * as moment from 'moment';
import {isArray, isDate, isFunction, isNull, isNullOrUndefined, isObject, isString, isUndefined} from 'util';
import {environment} from '../../environments/environment';

export class TableFilter {
  constructor(private omit?: string[]) {}

  private toString(rec: any, useToString: boolean = false) {
    const me = this;
    if ( !isNullOrUndefined(rec)) {

      // FIXME K£ migliorare il to string che esiste sempre e fa casino... dovremmo farlo solo per EntityBase?
      if ( useToString && isFunction(rec['toString'])) {
        return rec.toString();
      } else if ( isDate(rec) ) {
        return moment(rec).format(environment.datePattern);
      } else if (moment(rec, moment.ISO_8601, true).isValid()) {
        return moment(rec, moment.ISO_8601, true).format(environment.datePattern);
      } else if (isArray(rec)) {
        if(rec && rec.length > 0) {
          return rec.map(item => !isNullOrUndefined(item) ? me.toString(item, false) + '' : '').reduce((previousValue, currentValue) => {
            return previousValue ? previousValue + currentValue : currentValue;
          });
        }else {
          return '';
        }
      } else if (isObject(rec)) {
        const array = Object.keys(rec).filter(key => !me.omit || !me.omit.includes(key) );
        if(array && array.length > 0) {
          return array.map(key => !isNullOrUndefined(rec[key]) ? me.toString(rec[key], false) + '' : '')
            .reduce((previousValue, currentValue) => {
              return previousValue ? previousValue + currentValue : currentValue;
            });
        } else {
          return '';
        }
      } else {
        return rec + '';
      }
    }

    return '';

  }

  recFilter(rec: any, filter: any): boolean {
    const me = this;

    if (isUndefined(filter) || isNull(filter) || filter === '' ) {
      return true;
    }else if (isString(filter)) {
      const recVal = me.toString(rec);
      return recVal.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    } else {
      throw new Error('IMPLEMENTA IL FILTRO!!!');
    }
  }

  listFilter (list: any[], filter: any) {
    const me = this;
    return list.filter(value => me.recFilter(value, filter) );
  }

};



// WEBPACK FOOTER //
// ./src/app/core/TableConfig.ts